import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { DataStreamerService } from '@services/stomp/data-streamer-service';
import { SnapshotControllerService } from '@generated/data-streamer-api/api/snapshot-controller.service';
import { StompConfig } from '@env/environment.type';

export type DaisiDataSourceId = 'daisi' | 'bridges';

@Injectable({
  providedIn: 'root',
})
export class DaisiDataStreamerService extends DataStreamerService<DaisiDataSourceId> {
  protected readonly snapshotControllerService = inject(SnapshotControllerService);

  override getConfig(): StompConfig | null {
    return environment.daisiStomp;
  }
}
